import React from 'react'
import HeaderTwo from '../header/HeaderTwo';
import BannerTwo from '../elements/BannerTwo';
import ServiceTwo from '../elements/ServiceTwo';
import AboutTwo from '../elements/AboutTwo';
import FaqTwo from '../elements/FaqTwo';
import PortfolioTwo from '../elements/PortfolioTwo';
import Pricing from '../elements/Pricing';
import WhychooseUs from '../elements/WhychooseUs';
import TestimonialsTwo from '../elements/TestimonialsTwo';
import BlogTwo from '../elements/BlogTwo';
import ContactTwo from '../elements/ContactTwo';
import FooterTwo from '../elements/FooterTwo';




function HomeTwo(){
    return(
    <div className="index-two">
        <HeaderTwo/>
        <main>
            <BannerTwo/>
            <ServiceTwo/>
            <AboutTwo/>
            <FaqTwo/>
             <PortfolioTwo/>
            <Pricing/>
            <WhychooseUs/>
            <TestimonialsTwo/>
            <BlogTwo/>
            <ContactTwo/>
            <FooterTwo/>

        </main>
    </div>
    )
}


export default HomeTwo